import { ArticleHeading4, Label, Tooltip, UIText2 } from '@cian/ui-kit';
import { IconProductCianLogo16 } from '@cian/ui-kit-design-tokens/icons';

import { FC } from 'react';

import styles from './UniqueForCianBadge.css';

export const UniqueForCianBadge: FC = () => (
  <Tooltip
    placement="bottom-start"
    theme="white"
    title={
      <div className={styles['content']}>
        <ArticleHeading4>Только на Циан</ArticleHeading4>
        <UIText2>
          За последние сутки мы не нашли этот объект
          <br />в открытом доступе на других агрегаторах
        </UIText2>
      </div>
    }
  >
    <Label
      background="accent-main-secondary"
      color="accent-main-primary"
      icon={<IconProductCianLogo16 color="icon-main-default" />}
    >
      Только на Циан
    </Label>
  </Tooltip>
);

UniqueForCianBadge.displayName = 'UniqueForCianBadge';
